<script>
    import {getContext, onMount} from "svelte";
    import {isEmptyObject, uuid} from "../../utils";
    import Button from "../button/button.svelte";
    export let title = "";
    export let text = "";
    export let icon = "";
    export let btnTxt = "";
    export let target = {};

    let cls = "sui-swiper-item";
    const id = uuid();

    const ctx = getContext("SwiperState");
    let unsubscribe;

    onMount(() => {
        if (ctx) {
            ctx.add({id, title, text, icon, btnTxt});
        }
        return () => {
            unsubscribe && unsubscribe();
        };
    });
</script>

<div class={cls} on:click>
    {#if isEmptyObject($$slots)}
        <div class={`${cls}-inner`}>
            <div class={`${cls}-content`}>
                <h4>{title}</h4>
                <div>
                    <span>{text}</span>
                    {#if btnTxt}
                        <Button
                            size="mini"
                            --sui-button-border-radius="12px"
                            --button-background-color="var(--swiper-color-text)"
                            --button-text-color="var(--swiper-bg-color)"
                            color="primary">{btnTxt}</Button
                        >
                    {/if}
                </div>
            </div>
            <img src={icon} class={`${cls}-icon`} alt="" />
        </div>
    {:else}
        <slot><!-- optional fallback --></slot>
    {/if}
</div>

<style lang="less">
    @import "./swiper.less";
</style>
